import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "./Reveal";
import { FAQS } from "@/lib/content";

export const Faq = () => (
  <section id="faq" className="py-24 sm:py-32 bg-[#F4F0E8]">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal><Overline>Questions</Overline></Reveal>
        <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl sm:text-5xl lg:text-6xl text-[#2D2A26]">Before we begin.</h2></Reveal>
      </div>
      <Reveal className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-[#D9D1C2]">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`f${i}`} data-testid={`faq-accordion-item-${i}`} className="border-b border-[#D9D1C2]">
              <AccordionTrigger className="py-7 text-left font-display text-2xl sm:text-3xl font-normal text-[#2D2A26] hover:no-underline hover:text-[#A8613C] transition-colors">{f.q}</AccordionTrigger>
              <AccordionContent className="text-base text-[#5E584F] leading-relaxed pb-7 max-w-2xl">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
